﻿/*globals GeoRepositoryDTO*/

import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';
import GeoRepository from '../repositories/geo-repository';

class FilterDesktop{
    
    constructor(filterDesktopDTO){
        this.__filterDesktopDTO = filterDesktopDTO;
        this.__$filterAnchors = jquery('.js-filter-item a');
        this.__filterBtnContainer = document.getElementById('js-filter-button');
        this.__filterBtn = document.getElementById('js-filter-submit');
        this.__filter = document.getElementById('FiltroInmuebles');
        this.__$btnFiltrar = jquery('#js-filter-submit');
        this.__$numHabs = jquery('#js-num-habs');
        this.__$numBanos = jquery('#js-num-banos');
        this.__$codDistUnico = jquery('#js-cod-dist');
        this.__$codDistritos = jquery('#js-cod-distritos');
        this.__$codZonas = jquery('#js-cod-zonas');
        this.__$codProv = jquery('#js-cod-prov');
        this.__$codPob = jquery('#js-cod-pob');
        this.__$codArea = jquery('#js-cod-area');
        this.__$filtrosAvanzados = jquery('#js-filtros-avanzados');
        this.__$btnsNumHabs =  jquery('.js-num-hab');
        this.__$btnsNumBanos =  jquery('.js-num-ban');
        this.__$allZonesAllDistZones = jquery('#js-all-zones-all-dist-zones');
        this.__$selectPoblaciones = jquery('#select-poblaciones');
        this.__$tipsInm2 = jquery('#js-tips-inm2');
        this.__$tipInmAgrupado = jquery('#js-tip-inm-agrupado');
        this.__$pvpMin = jquery("#FiltrosViewModel_Filtros_PvpMin");
        this.__$pvpMax = jquery("#FiltrosViewModel_Filtros_PvpMax");
        this.__$containerZonas = jquery('#js-container-zones');
        this.__$filtrosAvanzadosContainer = jquery('#js-advanced-filters');
        this.__formFiltros = document.forms.FiltroInmuebles;
        this.__geoRepository = new GeoRepository(GeoRepositoryDTO);
        this.registerEvents();
        this.initFilterData();
    }

    registerEvents(){

        window.addEventListener('scroll', ()=>{
            this.checkFilterBtn();
        });

        window.addEventListener('resize', ()=>{
            this.checkFilterBtn();
        });

        this.__filter && this.__filter.addEventListener('change', () =>{
            this.activateFilterBtn();
        });

        this.__$filterAnchors.click((event) => {
            event.preventDefault();
            let $currentAnchor = jquery(event.currentTarget);
            $currentAnchor.prev().click();
        });

        this.__$btnFiltrar.click(() => {
            
        	this.__$numHabs.val(this.getNumHabs());
        	this.__$numBanos.val(this.getNumBanos());
            this.__$filtrosAvanzados.val(this.getFiltrosAvanzados());
            

            const distritosSeleccionados = this.getDistritosSeleccionados();
            const zonasSeleccionadas = this.getZonasSeleccionadas();
            this.__$codDistritos.val(distritosSeleccionados);
            this.__$codZonas.val(zonasSeleccionadas);

            if (!distritosSeleccionados) {
                this.__$codDistUnico.val('');
            }

            const tipos = this.getTipInm();
            this.__$tipsInm2.val(tipos.tipsInm2);
            this.__$tipInmAgrupado.val(tipos.tipInmAgrupado);

            const esFormularioCorrecto = this.getEsFormularioCorrecto();
        
            if (esFormularioCorrecto){

                if (typeof (Storage) !== "undefined" && !!window.sessionStorage) {
                    try { //for safari private
                        var testKey = 'test', storage = window.sessionStorage;
                        storage.setItem(testKey, '1');
                        storage.removeItem(testKey);
                        this.hasLocalStorage = true;
                    } catch (error) {
                        this.hasLocalStorage = false;
                    }
                }

                if (this.hasLocalStorage && !sessionStorage.getItem('MostrarModalCrearAlertaEnProvinciasEspeciales'))
                {
                    sessionStorage.setItem('MostrarModalCrearAlertaEnProvinciasEspeciales', true);
                }
                this.__formFiltros.submit();
            }
            
        });

        this.__$selectPoblaciones.change((event) => {
            const poblacion = jquery(event.currentTarget).val().split("-");

            if (poblacion.length === 4) {
                //const codProv = this.__$codProv.val();
                const codPob = poblacion[1];
                const codArea = poblacion[2];
                const poblacionConZonas = poblacion[3] === '1';

                this.__$codPob.val(codPob);
                this.__$codArea.val(codArea);

                if (poblacionConZonas) {
                    this.getZonasAndRender(codPob);
                }
                else {
                    this.checkUncheckAllDistAndZones(false);
                    this.__$txtAllZonas.removeClass('some-item');
                    this.__$containerZonas.addClass('hide-none');
                }

            } else {
                this.checkUncheckAllDistAndZones(false);
                this.__$txtAllZonas.removeClass('some-item');
                this.__$containerZonas.addClass('hide-none');
            }

            this.__$codZonas.val('');
            this.__$codDistritos.val('');
            this.__$codDistUnico.val('');
        });

        this.__$btnsNumHabs.click((event) => {

            const $currentTarget = jquery(event.currentTarget);
            if ($currentTarget.hasClass('active')) {
                $currentTarget.removeClass('active');
            } else {
                this.__$btnsNumHabs.removeClass('active');
                $currentTarget.addClass('active');
            }

            this.activateFilterBtn();
        });

        this.__$btnsNumBanos.click((event) => {

        	const $currentTarget = jquery(event.currentTarget);
        	if ($currentTarget.hasClass('active')) {
        		$currentTarget.removeClass('active');
        	} else {
        		this.__$btnsNumBanos.removeClass('active');
        		$currentTarget.addClass('active');
        	}

        	this.activateFilterBtn();
        });


        this.__$pvpMin.change((event) => {
            const currentPrice = jquery(event.currentTarget).children('option:selected')[0].value;
            this.__$pvpMin.children('[value="0"]').text(this.__filterDesktopDTO.translates.withoutMinPrice);
            this.updatePvpMax(currentPrice);
            jquery.publish(HabEvents.EventsEnum.ChangePvpMin);
        });
        this.__$pvpMax.change((event) => {
            const currentPrice = jquery(event.currentTarget).children('option:selected')[0].value;
            this.__$pvpMax.children('[value="0"]').text(this.__filterDesktopDTO.translates.withoutMaxPrice);
            this.updatePvpMin(currentPrice);
            jquery.publish(HabEvents.EventsEnum.ChangePvpMax);
        });

        if (this.__filterDesktopDTO && !this.__filterDesktopDTO.isDevice){
            this.__$pvpMin.mouseover(()=>{
                this.__$pvpMin.children('[value="0"]').text(this.__filterDesktopDTO.translates.noLimit);
            });

            this.__$pvpMax.mouseover(()=>{
                this.__$pvpMax.children('[value="0"]').text(this.__filterDesktopDTO.translates.noLimit);
            });

            this.__$pvpMin.mouseout(()=>{
                this.__$pvpMin.children('[value="0"]').text(this.__filterDesktopDTO.translates.withoutMinPrice);
            });

            this.__$pvpMax.mouseout(()=>{
                this.__$pvpMax.children('[value="0"]').text(this.__filterDesktopDTO.translates.withoutMaxPrice);
            });
        }

        this.__$filtrosAvanzadosContainer.click(()=>{
            this.__$filtrosAvanzadosContainer.addClass('advanced-filters-opened');
        });

        this.registerEventsDistZones();

    }

    registerEventsDistZones(){

        this.__$collapseAll = jquery('#js-collapse-all');
        this.__$allDist = jquery('#js-all-dist-zones');
        this.__$collapseZonesDist = jquery('.js-collapse-zones-of-dist');
        this.__$todaslaszonas = jquery('#todaslaszonas');
        this.__$txtAllZonas = jquery('#txt-all-zones');
        this.__$inputsDist = jquery('.js-dist');
        this.__$inputsZonas = jquery('.js-zona');
        this.__$lblTodasZonas = jquery('#js-lbl-todaslaszonas');

        this.__$lblTodasZonas.click((event) => {
            if (this.__$txtAllZonas.hasClass('close')) {
                this.uncollapseAll(this.__$collapseAll);
                event.preventDefault();
                event.stopPropagation();
            }
        });

        this.__$collapseAll.click((event) => {
            const $element = jquery(event.currentTarget);

            if ($element.hasClass('close')) {
                this.uncollapseAll($element);
                
            } else {
                this.collapseAll($element);
            }
        });

        this.__$collapseZonesDist.click((event) => {
            const $element = jquery(event.currentTarget);
            const codDist = $element.attr('data-cod-dist');

            const $zones = jquery(`#js-zones-${codDist}`);
            
            if($element.hasClass('close')){
                $element.removeClass('close');
                $zones.removeClass('hide-none');
            }else{
                $element.addClass('close');
                $zones.addClass('hide-none');
            }
        });


        this.__$todaslaszonas.click((event) => {
        
            const check  = event.currentTarget.checked;
            
            this.__$txtAllZonas.removeClass('some-item');

            this.checkUncheckAllDistAndZones(check);
        });

        this.__$inputsDist.click((event) => {
            const check  = event.currentTarget.checked;
            const $element = jquery(event.currentTarget);
            const codDist = $element.attr('data-cod-dist');
            const $inputsZonesOfDist = jquery(`.js-zonas-${codDist}`);
            $inputsZonesOfDist.prop('checked', check);

            if (!check) {
                const labelDist = jquery(`#txt-nom-dist-${codDist}`);
                labelDist.removeClass('some-item');
            }


            this.setStateOfAllZones();
        });

        this.__$inputsZonas.click((event) => {
        
            const $element = jquery(event.currentTarget);
            const codDist = $element.attr('data-cod-dist');

            if (codDist) {
                const numberOfZonasOfDist = jquery(`.js-zonas-${codDist}`).length;
                const numberOfZonasOfDistSelected = jquery(`.js-zonas-${codDist}:checked`).length;
                const $inputDistOfZone = jquery(`#dist-${codDist}`);
                const $txtDistOfZone = jquery(`#txt-nom-dist-${codDist}`);

                $inputDistOfZone.prop('checked', false);
                
                if(numberOfZonasOfDistSelected === 0){
                    $txtDistOfZone.removeClass('some-item');
                } else {
                    if (numberOfZonasOfDist !== numberOfZonasOfDistSelected){
                        $txtDistOfZone.addClass('some-item');
                    } 

                    $inputDistOfZone.prop('checked', true);
                }
            }

            this.setStateOfAllZones();


        });
    }

    uncollapseAll($element) {
        $element.removeClass('close');
        this.__$allDist.removeClass('hide-none');
        this.__$txtAllZonas.removeClass('close');

        if (this.__$txtAllZonas.hasClass('some-item')) {
            this.__$txtAllZonas.text(this.__filterDesktopDTO.translates.allZones);
        }
    }

    collapseAll($element) {
        $element.addClass('close');
        this.__$allDist.addClass('hide-none');
        this.__$txtAllZonas.addClass('close');
        if (this.__$txtAllZonas.hasClass('some-item')) {
            this.__$txtAllZonas.text(this.__filterDesktopDTO.translates.someZones);
        }
    }

    updatePvpMin(currentPrice) {
        const self = this;
        const actualSelected = this.__$pvpMin.children(':selected')[0].value;
        currentPrice = parseInt(currentPrice);
        this.__$pvpMin.html('');
        for (var i = 0; i < this.__filterDesktopDTO.priceList.length; i++) {
            if (i === 0) {
                self.__$pvpMin.append(`<option value="0">${this.__filterDesktopDTO.translates.withoutMinPrice}</option>`);
            }
            const price = this.__filterDesktopDTO.priceList[i];
            if (parseInt(price) < currentPrice || currentPrice===0) {
                self.__$pvpMin.append(`<option value="${price}">${this.__filterDesktopDTO.currencyPriceList[i]}</option>`);
            }
        }
        if (actualSelected < currentPrice) {
            this.__$pvpMin.val(actualSelected);
        }
    }

    updatePvpMax(currentPrice) {
        const self = this;
        const actualSelected = parseInt(this.__$pvpMax.children(':selected')[0].value);
        currentPrice = parseInt(currentPrice);
        this.__$pvpMax.html('');
        for (var i = 0; i<this.__filterDesktopDTO.priceList.length; i++) {
            if (i === 0) {
                self.__$pvpMax.append(`<option value="0">${this.__filterDesktopDTO.translates.withoutMaxPrice}</option>`);
            }
            var price = this.__filterDesktopDTO.priceList[i];
            if (parseInt(price) > currentPrice || currentPrice === 0) {
                self.__$pvpMax.append(`<option value="${price}">${this.__filterDesktopDTO.currencyPriceList[i]}</option>`);
            }
        }
        if (actualSelected > currentPrice) {
            this.__$pvpMax.val(actualSelected);
        }
    }

    setStateOfAllZones(){
        this.__$todaslaszonas.prop('checked', false);

        if ( this.__$inputsDist.length === 0){
            const numberOfZonasChecked = jquery('.js-zona:checked').length;
            
            if (numberOfZonasChecked === 0){
                this.__$txtAllZonas.removeClass('some-item');
            } else {
                if (this.__$inputsZonas.length !== numberOfZonasChecked) {
                    this.__$txtAllZonas.addClass('some-item');
                } else {
                    this.__$todaslaszonas.prop('checked', true);
                }
            }
        }else{
            const numberOfDistsChecked = jquery('.js-dist:checked').length;
            
            if (numberOfDistsChecked === 0){
                this.__$txtAllZonas.removeClass('some-item');
            } else {
                if (this.__$inputsDist.length !== numberOfDistsChecked) {
                    this.__$txtAllZonas.addClass('some-item');
                } else {
                    this.__$todaslaszonas.prop('checked', true);
                }
            }
        }
        
    }


    getNumHabs(){
        return jquery('.js-num-hab.active').attr('data-num-hab');
    }

    getNumBanos(){
    	return jquery('.js-num-ban.active').attr('data-num-ban');
    }

    getFiltrosAvanzados(){
        const checksFiltros = jquery('.chkfiltros:checked');
        let listaFiltros= '';
        
        for(var i = 0; i < checksFiltros.length; i++){
            listaFiltros = listaFiltros + (checksFiltros[i].value) + '_';
        }

        if (listaFiltros.length > 0) {
            listaFiltros = listaFiltros.substring(0, listaFiltros.length - 1);
        }

        return listaFiltros;
    }

    getTipInm(){
        const tipInmsSelected = jquery('.chksubtipos:checked');
        const tipInms = jquery('.chksubtipos');
        const numTipinmSelected = tipInmsSelected.length;
        let tipsInm2 = '';
        let ids = '';

        if (tipInmsSelected.length > 0 && tipInms.length !== tipInmsSelected.length) {
            for (let i = 0; i < numTipinmSelected; i++) {
                const item = tipInmsSelected[i];
                tipsInm2 += item.getAttribute("data-tipsInm2") + ",";
                ids += item.getAttribute("id") + ",";
            }

            if (tipsInm2.length > 0) {
                tipsInm2 = tipsInm2.substring(0, tipsInm2.length - 1);
            }

            if (ids.length > 0) {
                ids = ids.substring(0, ids.length - 1);
            }
        }

        return {
            tipsInm2: tipsInm2,
            tipInmAgrupado: ids
        };
    }




    initFilterData(){

	    this.__filterDesktopDTO && this.__$numHabs.val(this.__filterDesktopDTO.numhab);

    }


    getEsFormularioCorrecto(){

        //TODO [Pedro]: Falta implementar
        return true;
    }

    getZonasSeleccionadas(){
        const inputsZonas = document.querySelectorAll('.js-zona');
        const inputsZonasSeleccionadas = document.querySelectorAll('.js-zona:checked');
        let zonasSeleccionadas = '';

        if (inputsZonasSeleccionadas.length > 0 && inputsZonas.length !== inputsZonasSeleccionadas.length){

            for(let i = 0, length = inputsZonasSeleccionadas.length; i < length; i++ ){
            
                zonasSeleccionadas += inputsZonasSeleccionadas[i].getAttribute('data-cod-zona');

                if (i < length - 1){
                    zonasSeleccionadas += ',';
                }
            }
        }

        return zonasSeleccionadas;
        
    }

    getDistritosSeleccionados(){
        const inputsDistritos = document.querySelectorAll('.js-dist');
        const inputsDistritosSeleccionados = document.querySelectorAll('.js-dist:checked');
        let distritosSeleccionados = '';

        if (inputsDistritosSeleccionados.length > 0 && inputsDistritos.length !== inputsDistritosSeleccionados.length){

            for(let i = 0, length = inputsDistritosSeleccionados.length; i < length; i++ ){
            
                distritosSeleccionados += inputsDistritosSeleccionados[i].getAttribute('data-cod-dist');

                if (i < length - 1){
                    distritosSeleccionados += ',';
                }
            }
        }

        return distritosSeleccionados;
        
    }

    getZonasAndRender(codPob) {
        this.__geoRepository.getZonas(codPob)
            .then((data) => {
                this.__$containerZonas.removeClass('hide-none');
                this.__$containerZonas.removeClass('ocultar');
                this.__$allZonesAllDistZones.empty();
                this.__$allZonesAllDistZones.html(data);
                this.__$allZonesAllDistZones.removeClass('hide-none');
                this.registerEventsDistZones();
            });

    }
    
    checkUncheckAllDistAndZones(check) {
        this.__$inputsDist.prop('checked', check);
        this.__$inputsZonas.prop('checked', check);
    }

    activateFilterBtn(){
        this.__filterBtnContainer.classList.add('filter-btn-active');
        this.__filterBtn.disabled = false;
        this.checkFilterBtn();

    }

    checkFilterBtn() {
        const offsetScroll = 200;
        const lngWindowHeight = window.innerHeight;

        if (this.__filter && (this.__filter.getBoundingClientRect().height + this.__filter.getBoundingClientRect().top >= lngWindowHeight) && !this.__filterBtn.disabled) {
            this.__filterBtnContainer.classList.add("filter-btn-active-fixed");
        }
        else if (this.__filter && (this.__filter.getBoundingClientRect().height + this.__filter.getBoundingClientRect().top + offsetScroll < lngWindowHeight)){ 
            this.__filterBtnContainer.classList.remove("filter-btn-active-fixed");
        }
    }
    
}


export default FilterDesktop;